import React, { Component } from 'react';
import './Site.css';
import { Row, Col } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Sparklines, SparklinesLine, SparklinesSpots } from 'react-sparklines';
import classnames from "classnames";

export default class ProductSparkline extends Component {
  static displayName = ProductSparkline.name;
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      messageColor: null,
      isMessageVisible: false,
    }
  }

  componentDidMount() {
  }

  render() {
    const productData = this.props.productData;
    return (
      <div>
        {productData ? (
          <Row className="p-2">
            <Col style={{ width: "150px" }}>
              <Row>
                <Col><span>Sales Counts: <span className="boldText">{productData.priorDaySaleCount}</span></span></Col>
              </Row>
              <Sparklines data={productData.shippingCountList} svgWidth={200} svgHeight={40} margin={5}>
                  <SparklinesLine color="#3399cc" />
                  <SparklinesSpots />
                </Sparklines>
              </Col>
            <Col>
              <Row>
                <Col><span>Production Counts: <span className="boldText">{productData.priorDayProductionCount}</span></span></Col>
              </Row>               
              <Sparklines data={productData.productionCountList} svgWidth={200} svgHeight={40} margin={5}>
                <SparklinesLine color="#ff9999" />
                  <SparklinesSpots />
                </Sparklines>
            </Col>
            <Col>
              <Row>
                <Col>
                  <span>Supply Level:</span>
                  <span className={classnames({ "badSupplyLevel": productData.isInventoryLow ? true : false }, { "goodSupplyLevel": !productData.isInventoryLow ? true : false }, "ml-2")}>
                    {productData.displaySupplyLevel}
                    {productData.isInventoryLow
                      ? <FontAwesomeIcon icon="caret-down" className="ml-2" />
                      : <FontAwesomeIcon icon="caret-up" className="ml-2" />
                    }
                  </span>
                </Col>
              </Row>
                <Row>
                <Col>
                  <span>{productData.preferredDemandDays} Day Demand:</span>
                  <span className="boldText ml-2">{productData.onHandDemand}</span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <span>Days on Hand:</span>
                  <span className="boldText ml-2">{productData.daysOnHand}</span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <span>Inventory Count:</span>
                  <span className="boldText ml-2">{productData.realTimeInventory}</span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <span>Current Cycle Count:</span>
                  <span className="cbdmdBlueText boldText ml-2">{productData.currentCycleCountTotal}</span>
                </Col>
              </Row>
            </Col>
           </Row>
        ) : null}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ProductSparkline.js